import { FileText, Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { OrderDocument } from '../hooks/useDocuments';
import { DocumentCard } from './DocumentCard';

interface DocumentsListProps {
  orderId: string;
  documents: OrderDocument[] | undefined;
  isLoading: boolean;
}

export function DocumentsList({ orderId, documents, isLoading }: DocumentsListProps) {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="flex flex-col items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-gray-400 mb-4" />
            <p className="text-gray-500">Loading documents...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <FileText className="h-8 w-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No Documents Yet</h3>
            <p className="text-gray-500 max-w-sm">
              Upload a Closing Disclosure document to get started. The document will be added to
              this order and can be processed when ready.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {documents.map((document) => (
        <DocumentCard key={document.id} orderId={orderId} document={document} />
      ))}
    </div>
  );
}
